import {IPageObserverEntry} from '../../Utilities/Helper.client';
import { toggleStickyPriceCompareButton } from '../StickyButtonPriceCompare/StickyButtonPriceCompare.client';

let isSearchFormLoaded: boolean = false;

export const getSearchFormContainer = (): HTMLElement | null => {
    return document.getElementById('vvv-search-form-widget');
};

const loadSearchFormScript = () => {
    if (isSearchFormLoaded === false) {
        isSearchFormLoaded = true;
        window.requestIdleCallback(() => {
            const script = document.createElement('script');
            script.setAttribute('type', 'text/javascript');
            script.setAttribute('defer', 'defer');
            script.setAttribute('src', __SEARCHFORM_URL__);
            document.body.appendChild(script);
        }, { timeout: 2000 });
    }
};

export const getSearchFormObservableEntry = (): IPageObserverEntry | null => {
   const target: HTMLElement | null = getSearchFormContainer();
    if (target === null) {
       return target;
    }

    return {
        element: target,
        callback: (entry: IntersectionObserverEntry): void => {
            // only load once
            if (entry.isIntersecting === true && entry.intersectionRatio > 0.5 && isSearchFormLoaded === false) {
                loadSearchFormScript();
            }

            toggleStickyPriceCompareButton(entry);
        }
    }
};
